<template>
<div class="login">
  <Header />

  <div class="bg-image"></div>

  <div class="login-area">
    <div class="section">
      <h1 class="white--text mb-7 text-center">Digite e-mail</h1>

      <div class="card login-card py-14">
        <v-form ref="form" autocomplete="off" @submit.prevent="handleForm" >
        
        <div v-for="(key,index) in Object.keys(inputs)" :key="key">
          <TextField
            :inputs="inputs"
            :inputName="key"
            :placeholder="placeholder[index]" 
            :inputType="inputTypes[index]" 
            :icon="icons[index]" 
            @onInputFocus="onInputFocus"
            @onInputChange="onInputChange"
          />
        </div>

       
        <strong v-if="showMessage && errorMessage" class="red--text">{{errorMessage}}</strong>

        <v-btn
          class="btn mt-4" block 
          color="primary"
          :disabled="isLoading"
          :loading="isLoading"
          @click.right="handleForm" 
          type="submit"
        >
          <img src="@/assets/ic-login.png" class="mr-2" alt=""> 
          Entrar
          <template v-slot:loader>
            <span>Carregando...</span>
          </template>
        </v-btn>

    </v-form>
  </div>
    </div>
  </div>

  <SimpleKeyboard 
    @onChange="onChange"
    @onKeyPress="onKeyPress"
    :input="inputs[inputName]"
    :inputName="inputName"
  />
</div>
</template>
<script>

import Header from '@/components/Header'
import TextField from '@/components/TextField'
import {signin} from '@/controllers/admin.controller'
import {getMessage} from '@/controllers/message.controller'

import SimpleKeyboard from '../../SimpleKeyboard'



export default {
  name: 'SignIn',
  components: {Header, TextField, SimpleKeyboard},
  data () {
    return {
      isLoading: false,
      errorMessage: '',
      showMessage: false,
      placeholder: [
        'email@gmail.com.br',
        'xxxxxxxxx'
      ],
      icons: [
        'mdi-email',
        'mdi-key'
      ],
      inputTypes:[
        'email',
        'password'
      ],
      inputs: {
        email: '',
        password: ''
      },
      inputName: "email",
    }
  },
  methods: {
    onChange(input) {
      this.inputs[this.inputName] = input;
    },
    onKeyPress() {
      // params button
      // console.log("button", button);
    },
    onInputChange(input) {
      this.inputs[input?.target.id] = input?.target.value;
    },
    onInputFocus(input) {
      this.inputName = input?.target.id;
    },
    handleClearInput(inputValue) {
      this.inputs[this.inputName] = inputValue;
    },
    getEmail(value) {
      this.email = value
    },
    getPassword(value) {
      this.password = value
    },
   async handleForm (e) {
      e.preventDefault()

      if (this.$refs.form.validate()) {
        this.isLoading = true
  
        const data = await signin(this.inputs.email.trim(), this.inputs.password.trim())


        if (!data) {
          this.showMessage = true
          
          this.errorMessage = getMessage()
          setTimeout(() => {
            this.errorMessage = ''
            this.showMessage = false
          }, 8000);
        }

        this.isLoading = false
      }

      
    },
  },
  mounted() {
    if (this.$route.params.dev) {
      this.inputs.email = 'alisson@teste.com.br'
      this.inputs.password = '123456'
    }
  }
}
</script>

<style scoped>
.white--text{
  color: #1A237E !important;
}

/* .login {
    overflow: hidden !important;
} */

/* .bg-image { */
  /* The image used */
  /* background-image: url('../../assets/background.png'); */
  
  /* Add the blur effect */
  /* filter: blur(24px); */
  /* -webkit-filter: blur(24px); */
  
  /* Full height */
  /* height: 100vh;  */
  
  /* Center and scale the image nicely */
  /* background-position: center;
  background-repeat: no-repeat;
  background-size: cover; */
/* } */

/* .login-area {
  background-color: rgb(0,0,0); 
  background-color: rgba(12, 204, 166, 0.6); 
  color: white;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 100%;
  height: 100vh;
  padding: 20px;
  text-align: center;
} */

/* .section {
    position: absolute;
    top: 40%;
    width: 446px;
    height: 232px;
    left: 50%;
    transform: translate(-50%, -50%);
} */

</style>